import { useLocaleStore } from '~/stores/locale'

export const useBlogUrl = () => {
  const localeStore = useLocaleStore()

  const blogUrl = computed(() => {
    const culture = localeStore.culture.toLowerCase()
    if (culture.startsWith('fr-ca')) { return 'https://blog.stampinup.com/fr-ca/' }
    if (culture.startsWith('fr')) { return 'https://blog.stampinup.com/fr/' }
    if (culture.startsWith('nl')) { return 'https://blog.stampinup.com/nl/' }
    if (culture.startsWith('de')) { return 'https://blog.stampinup.com/de/' }
    return 'https://blog.stampinup.com'
  })

  return { blogUrl }
}
